import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'
import './setting.scss'
import { useDispatch } from 'react-redux';
import { SETTING } from './../../constants/setting'
import { useSelector } from 'react-redux'
import InspectionProcessService from "./../../services/inspectionProcessService"
import {
  Tabs
} from 'antd';
import _ from 'lodash';
import SettingGeneral from './general';
import SettingWeb from './web';
import RestSetting from './restSetting';
import PaymentSetting from './PaymentSetting';
import ServiceSetting from './ServiceSetting';
import ExpandSetting from './ExpandSetting';
import MiniApp from './MiniApp';
import Webhooks from './Webhooks';
import PaymentMethod from './PaymentMethod';
import BasicTabs from 'components/BasicTabs';
import { ALL_PERMISSION } from 'constants/permission';
import Utilities from './_components/Utilities';
import AIAssistant from './AIAssistant';

const SETTING_GENERAL = 'SETTING_GENERAL'
const SETTING_WEB = 'SETTING_WEB'
const SETTING_PAYMENT = 'SETTING_PAYMENT'
const SETTING_SERVICE = "SETTING_SERVICE"
const SETTING_EXPAND = "SETTING_EXPAND"
const SETTING_EXPAND_MINIAPP = "SETTING_EXPAND_MINIAPP"
const SETTING_EXPAND_WEBHOOKS = "SETTING_EXPAND_WEBHOOKS"
const SETTING_PAYMENT_METHOD = "SETTING_PAYMENT_METHOD"
const SETTING_EXPAND_UTILITIES = "SETTING_EXPAND_UTILITIES"

function Setting() {
  const { t: translation } = useTranslation()
  const listTab = [{
    key: SETTING_GENERAL,
    label :translation("setting.generalInfo"),
    permission: undefined,
    component: <SettingGeneral />,
  },
  // {
  //   key: SETTING_PAYMENT,
  //   label :translation("setting.payment.payment"),
  //   permission: undefined,
  //   component: <PaymentSetting/>,
  // }
  // {
  //   key: SETTING_SERVICE,
  //   label :translation("setting.service.service"),
  //   permission: undefined,
  //   component: <ServiceSetting />,
  //   isHidden: process.env.REACT_APP_THEME_NAME  === "HCMTAX"
  // },
  {
    key: SETTING_EXPAND,
    label :translation("setting.service.expand"),
    permission: undefined,
    component: <ExpandSetting/>,
  },
  {
    key: SETTING_EXPAND_MINIAPP,
    label: translation("setting.service.miniApp"),
    permission: undefined, // nếu cần phân quyền sau này
    component: <MiniApp />,
    isHidden: process.env.REACT_APP_THEME_NAME  === "HCMTAX"
  },
  {
    key: SETTING_EXPAND_WEBHOOKS,
    label: translation("setting.service.webhooks"),
    permission: undefined,
    component: <Webhooks />,
    isHidden: process.env.REACT_APP_THEME_NAME  === "HCMTAX"
  },
  // {
  //   key: SETTING_REST,
  //   label: translation("setting.rest"),
  //   permission: undefined,
  //   component: <RestSetting />,
  // },
  {
    key: SETTING_PAYMENT_METHOD,
    label: translation("setting.service.paymentMethod"),
    permission: undefined,
    component: <PaymentMethod />,
    isHidden: process.env.REACT_APP_THEME_NAME  === "HCMTAX"
  },
  {
    key: SETTING_EXPAND_UTILITIES,
    label: translation("setting.service.utilities"),
    permission: undefined,
    component: <Utilities />,
    isHidden: process.env.REACT_APP_THEME_NAME  === "HCMTAX"
  },
  // {
  //   key: SETTING_EXPAND_AI_ASSISTANT,
  //   label: translation("setting.ai.AIAssistant"),
  //   permission: undefined,
  //   component: <AIAssistant />,
  // }
]

  return (
    <>
      <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGE_SETTINGS.permissionTab} />
    </>
  )
}
export default Setting;
